import React from 'react';
import {useSelector} from 'react-redux';

import {fetchActiveChatSessions, fetchChatMessages} from '../../data/fetch';
import Loader from './Loader';

const LoadChatRoom = ({sessionId, children}) => {
    // Skip loader if there is no chat id
    if (!sessionId) return children;

    return (
        <Loader
            id={`load-chat-room-${sessionId}`}
            skipSpinner={state => state.chat.loaded && state.chat.indexed[sessionId].messagesLoaded}
            promises={[fetchActiveChatSessions(), fetchChatMessages(sessionId)]}
            key={`load-chat-room-${sessionId}`}>
            {children}
        </Loader>
    );
};

export default LoadChatRoom;
